import { render, staticRenderFns } from "./groupProjectsRecords.vue?vue&type=template&id=7bf7c558&"
import script from "./groupProjectsRecords.vue?vue&type=script&lang=js&"
export * from "./groupProjectsRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports